<main>
  <ng-container *transloco="let t">
    <section class="wallpaper"></section>

    <section class="login">
      <div style="display: flex; flex-direction: column; max-width: 360px">
        <div class="logo-wrapper">
          <p class="logo"></p>
        </div>
        <div class="welcome-text">
          <h2>{{ t('Welcome to Anihis') }}</h2>
          <p>{{ t('Welcome! Please enter your email and password') }}.</p>
        </div>
        <div>
          <form [formGroup]="form" [enterAction]="onEnterLogin">
            <div class="sm:mx-auto sm:w-full sm:max-w-sm flex flex-col gap-4">
              <div>
                <label
                  for="email"
                  class="block text-sm font-medium leading-6 text-gray-900"
                  >{{ t('Email') }}</label
                >
                <div class="relative mt-2 rounded-md shadow-sm">
                  <div
                    class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
                  >
                    <span class="icon email-icon"></span>
                  </div>
                  <input
                    formControlName="email"
                    id="email"
                    name="email"
                    type="email"
                    autocomplete="email"
                    required
                    class="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>

                @if (
                  showValidationErrors() &&
                  form.controls['email'].hasError('pattern')
                ) {
                  <mat-error>
                    {{ t('Enter valid email') }}
                  </mat-error>
                }

                @if (
                  showValidationErrors() &&
                  form.controls['email'].hasError('required')
                ) {
                  <mat-error>
                    {{ t('Email is required') }}
                  </mat-error>
                }
              </div>

              <div>
                <label
                  for="password"
                  class="block text-sm font-medium leading-6 text-gray-900"
                  >{{ t('Password') }}</label
                >
                <div class="relative mt-2 rounded-md shadow-sm">
                  <div
                    class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3"
                  >
                    <span class="icon password-icon"></span>
                  </div>

                  <input
                    matInput
                    formControlName="password"
                    id="password"
                    [type]="showPassword() ? 'text' : 'password'"
                    class="block w-full rounded-md border-0 py-1.5 pl-10 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />

                  <button
                    type="button"
                    class="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer border-none bg-transparent"
                    (click)="showPassword.set(!showPassword())"
                    [attr.aria-label]="
                      showPassword() ? t('Hide password') : t('Show password')
                    "
                    [attr.aria-pressed]="showPassword()"
                  >
                    <span
                      class="icon"
                      [ngClass]="
                        showPassword() ? 'eye-off-grey-icon' : 'eye-grey-icon'
                      "
                    ></span>
                  </button>
                </div>

                @if (
                  showValidationErrors() &&
                  form.controls['password'].hasError('required')
                ) {
                  <mat-error>
                    {{ t('Password is required') }}
                  </mat-error>
                }
                @if (
                  showValidationErrors() &&
                  form.controls['password'].hasError('pattern')
                ) {
                  <mat-error>
                    {{ t('Invalid password format') }}
                  </mat-error>
                }
              </div>

              <button
                mat-flat-button
                type="button"
                class="primary-btn"
                [disabled]="store.status() === status.Loading"
                (click)="login()"
              >
                @if (store.status() !== status.Loading) {
                  {{ t('Sign in') }}
                } @else {
                  <span
                    class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"
                  ></span>
                  {{ t('Signing in...') }}
                }
              </button>
            </div>
            <button
              type="button"
              class="bg-transparent border-none p-0 m-0"
              (click)="redirectToForgotPassword()"
            >
              <span class="cursor">{{ t('Forgot password') }}</span>
            </button>
            <button
              type="button"
              class="bg-transparent border-none p-0 m-0"
              (click)="redirectToActivateAccount()"
            >
              <span class="cursor">{{ t('Activate account') }}</span>
            </button>
          </form>
        </div>
        <div class="legal-links">
          <a [routerLink]="['/privacy-policy']">{{ t('legal.pp.title') }}</a>
          <span class="separator">·</span>
          <a [routerLink]="['/terms-of-service']">{{ t('legal.tos.title') }}</a>
          <span class="separator">·</span>
          <a [href]="'mailto:' + supportEmail">{{ t('Support') }}</a>
          <span class="separator">·</span>
          <a [routerLink]="['/impressum']">{{ t('legal.impressum.title') }}</a>
        </div>
      </div>
    </section>
  </ng-container>
</main>
